import React, { useState, useContext, useEffect, useRef } from 'react';
import { submitForm, findItemByStatus } from './utils/OutOfStockUtil';
import { OutOfStock } from './OutOfStock';
import proptypes from 'prop-types';
const { string, bool, arrayOf } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { getDomPath } from '@thd-olt-functional/utils';
import { MESSAGE_STATES, BUNDLE_TRACK_OOS_MESSAGE } from './constants';

const TrackMultiOutOfStock = ({ itemIds, enableSms, legalDisclaimer }) => {

  const context = useContext(ExperienceContext);
  const ref = useRef();
  const statusRef = useRef([]);
  const [state, setState] = useState({
    status: 'init',
    loader: false
  });

  const updateState = (status, loader) => {
    setState((prevState) => ({
      ...prevState,
      loader,
      status
    }));
  };

  const handleOnSubmit = async ({ values }) => {
    statusRef.current = [];
    await Promise.allSettled(itemIds?.map(async (itemId) => {
      await submitForm(values, itemId, statusRef, context);
    })).then(() => {
      if (statusRef?.current?.length) {
        const failureItem = findItemByStatus(statusRef, 'failure');
        const successItem = findItemByStatus(statusRef, 'success');
        const duplicateItem = findItemByStatus(statusRef, 'duplicate');
        const { status, loader } = failureItem || successItem || duplicateItem || statusRef?.current?.[0];
        updateState(status, loader);
      }
    }
    );
  };

  const { status } = state;

  const trackError = (domPath) => {
    const message = MESSAGE_STATES[status]?.message;
    window.LIFE_CYCLE_EVENT_BUS.trigger('track-out-of-stock.click', { message, domPath });
  };

  useEffect(() => {
    if (['init', 'success', 'duplicate'].includes(status)) {
      return;
    }
    const _path = getDomPath(ref);
    trackError(_path);
  }, [status]);

  return (
    <OutOfStock
      enableSms={enableSms}
      legalDisclaimer={legalDisclaimer}
      handleOnSubmit={handleOnSubmit}
      status={status}
      updateState={updateState}
      buttonRef={ref}
      oosMessageText={BUNDLE_TRACK_OOS_MESSAGE}
    />);
};

TrackMultiOutOfStock.displayName = 'TrackMultiOutOfStock';

TrackMultiOutOfStock.dataModel = {};

TrackMultiOutOfStock.propTypes = {
  itemIds: arrayOf(string),
  enableSms: bool,
  legalDisclaimer: string
};

TrackMultiOutOfStock.defaultProps = {
  itemIds: [],
  enableSms: false,
  legalDisclaimer: null
};

export { TrackMultiOutOfStock };
